import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index'
import notification from 'ant-design-vue/es/notification'
import modal from 'ant-design-vue/es/modal'
import {VueAxios} from './axios'
import {ACCESS_TOKEN} from '../store/mutation-types'
import {getSystemConfig} from './requestFail'
import store from '../store'

const env = process.env.NODE_ENV

export const casLoginUrl = '${CAS_PREFIX}/login?service=${CALLBACK}'
export const casLogoutUrl = '${CAS_PREFIX}/logout?service=${CALLBACK}'
export const CasConfigKey = 'casUrl'
export const UserInfoKey = 'UserInfoKey'
export const UserNameKey = 'userNameKey'
export const UserEmailKey = 'UserEmailKey'
export const UserIdKey = 'UserIdKey'
export const UserTokenKey = 'UserTokenKey'

export const  SERVICE_AUTHENTICATION_DEV= 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjI0OTAiLCJzZXJ2aWNlS2V5IjoiNjgzYTZkMTJiN2E2NDg2MWIxOWQwYWYyZmRiM2Y0MDYiLCJzZXJ2aWNlVHlwZSI6IjEiLCJzZXJ2aWNlQXBwIjoiMTY2Iiwic2VydmljZUNsdXN0ZXIiOiIyIiwianRpIjoiMjM3ZTg4MzRlMjY0NDVkZTkxZWQ0YjQxOTlhYjRiMGQiLCJpYXQiOjE1OTcxOTc1ODF9.umqbMlAsvlOUcLULMzS8En8S6dnrRd8bIwdypr-FbWw'
export const  SERVICE_AUTHENTICATION_UAT= 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjI0OTAiLCJzZXJ2aWNlS2V5IjoiZmM2NGY1MDAyMTkzNDA5NTg1ZDE2OWZiYmVhODZhMWIiLCJzZXJ2aWNlVHlwZSI6IjEiLCJzZXJ2aWNlQXBwIjoiMTY2Iiwic2VydmljZUNsdXN0ZXIiOiIzIiwianRpIjoiOGZhZmYzNzIzYWFmNDEzZWEzM2I2OTgzNWU0YWE3YzUiLCJpYXQiOjE1OTcxMTMwOTR9.YlzDC7ogP4t2kciu_ArnCwA1krq9caiuBiGOWljD7K0'
// export const  SERVICE_AUTHENTICATION_PROD= 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjI0OTAiLCJzZXJ2aWNlS2V5IjoiYmVkNDIxNjJjZDE3NDc2ODhlYTdlNjkzMzVhNGExMjYiLCJzZXJ2aWNlVHlwZSI6IjEiLCJzZXJ2aWNlQXBwIjoiMTY2Iiwic2VydmljZUNsdXN0ZXIiOiIxMCIsImp0aSI6IjRlNDhlNGFhNjE1ZjQ5OTFiNjhmZTBjOTZiZTRlYTE4IiwiaWF0IjoxNTk5NDYyNzY4fQ.4rGlXeyNPyRqrn7w4yP0bmI1nh2YKWPM_UveWTTux9A'
export const  SERVICE_AUTHENTICATION_PROD= 'eyJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlTmFtZSI6IjI0OTAiLCJmdWxsU2VydmljZU5hbWUiOiJzY2N0LS1sb2Mtc2VydmljZSIsInNlcnZpY2VLZXkiOiIwZDYzNjI0YzJkMWE0MTI5YmIyYWU3ODA0YmEzYmI3NSIsInNlcnZpY2VUeXBlIjoiMSIsInNlcnZpY2VBcHAiOiIxNjYiLCJzZXJ2aWNlQ2x1c3RlciI6IjIzIiwianRpIjoiMDgzMmNkMWM5YzgyNGIxYWEwYzc5NjEzZTY0ZThlZjQiLCJpYXQiOjE2ODY3MjY1MDh9.kT8-rlQxLdYsheKiCto7q263FqVImoExuvgc41g9Dm0'

// const baseURL = '/api';
// const baseURL = '/loc-portal-dev'
// const baseURL = '/loc-portal-uat';
const baseURL = '/loc-portal-prod';  // 生产

const service = axios.create({
    baseURL: baseURL, // api base_url
    timeout: 180000, // 请求超时时间
    withCredentials: true
})

function getCheckUrl(url) {
    try {
        /* route API url for SCCT: xxx/routes/rpk/aaa/bbb/ccc */
        if (url.match(/^.*routes\/rpk\/.+$/i)) {
            return 'tt_rpk_cas_check.do'
        }
    } catch (err) {
    }
    return 'loc_j_spring_cas_security_check.do'
}


let errBtn = false
let errModal = false
const err = (error) => {
    if (error.response) {
        const data = error.response.data
        // console.log(error.response)
        if (error.response.status === 401 && !errBtn) {
            errBtn = true
            store.dispatch('removeUserInfo', {}).then(r => {
                if (errBtn) {
                    if (router.currentRoute.path === '/login') {
                    } else {
                        location.reload()// 为了重新实例化vue-router对象 避免bug
                    }

                }
                errBtn = false
            })
        } else if (error.response.status !==401 && !errBtn && !errModal) {
            errBtn = true
            errModal = true
            if (error.response.config.url.indexOf('.pdf') !== -1) {
            } else {
                const  msg = error.response.data['message'] ? error.response.data['message'] : (error.response['message'] ? error.response['message'] : 'No Error Message Response')
                if (msg && msg.length > 0) {
                    modal.error(
                        {
                            title: 'Error',
                            content: msg,
                            onOk: () => {
                                errModal = false
                                errBtn = false
                                if (router.history.current.name === 'Home') {
                                } else {
                                    router.push({
                                        path: '/'
                                    })
                                }

                            }
                        }
                    )
                }
            }
        }
    }
    return Promise.reject(error)

}

// request interceptor
service.interceptors.request.use(config => {
    const token = store.getters.getToken //
    if (token) {
        config.headers['X-CSRF-TOKEN'] = token
    }
    if (baseURL === '/loc-portal-dev') {
        config.headers['SERVICE-AUTHENTICATION'] = SERVICE_AUTHENTICATION_DEV
    } else if (baseURL === '/loc-portal-uat') {
        config.headers['SERVICE-AUTHENTICATION'] = SERVICE_AUTHENTICATION_UAT
    } else if (baseURL === '/loc-portal-prod') {
        config.headers['SERVICE-AUTHENTICATION'] = SERVICE_AUTHENTICATION_PROD
    }  else if (baseURL === '/api') {
        // config.headers['SERVICE-AUTHENTICATION'] = SERVICE_AUTHENTICATION_DEV
        config.headers['SERVICE-AUTHENTICATION'] = SERVICE_AUTHENTICATION_UAT
    }

    // console.log(123123)
    return config
}, (error) => {
    Promise.reject(error)
})
// response interceptor
service.interceptors.response.use((response) => {
    errBtn = false
    // console.log('response : ', response)
    // if (response.status !== 200) {
    //     const  msg = response.data['message'] ? response.data['message'] : (response['message'] ? response['message'] : 'Error')
    //     modal.error(
    //         {
    //             title: 'Error',
    //             content: msg,
    //             onOk: () => {
    //                 router.push({
    //                     path: '/'
    //                 })
    //             }
    //         }
    //     )
    // } else {
    //     return response.data
    // }
    if (response.status === 200) {
        return response.data
    } else {
        return response
    }
}, (error) => {
    err(error)
})

const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, service)
    }
}

export {
    installer as VueAxios,
    service as axios,
    baseURL as baseURL,

}
